export default __webpack_public_path__ + "a0b3d0dfcb3f167e0d55d4b0330059a7.mp4";